// Cookie consent utility — gates analytics/marketing scripts behind user consent (Quebec Law 25)
const CONSENT_KEY = 'entrepot_cookie_consent';

export const COOKIE_CATEGORIES = {
  essential: 'essential',
  analytics: 'analytics',
  marketing: 'marketing',
};

const DEFAULT_CONSENT = {
  essential: true,
  analytics: false,
  marketing: false,
  timestamp: null,
};

export const getConsent = () => {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored) return JSON.parse(stored);
  } catch {}
  return null;
};

export const setConsent = (consent) => {
  const data = { ...consent, timestamp: new Date().toISOString() };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(data));
  window.dispatchEvent(new CustomEvent('cookie-consent-updated', { detail: data }));
  return data;
};

export const acceptAll = () => setConsent({ essential: true, analytics: true, marketing: true });

export const rejectAll = () => setConsent({ ...DEFAULT_CONSENT });

export const hasConsented = () => getConsent() !== null;

export const hasAnalyticsConsent = () => {
  const consent = getConsent();
  return consent?.analytics === true;
};

export const hasMarketingConsent = () => {
  const consent = getConsent();
  return consent?.marketing === true;
};
